import { PDFName } from "pdf-lib"

export type PdfBoxSizeInches = {
  width: number
  height: number
}

export const getPdfBytes = async (
  source: string | File[] | Uint8Array,
): Promise<Uint8Array> => {
  if (typeof source === "string") {
    const response = await fetch(source)
    if (!response.ok) {
      throw new Error(`Failed to fetch PDF (${response.status})`)
    }
    return new Uint8Array(await response.arrayBuffer())
  }

  if (source instanceof Uint8Array) {
    return source
  }

  if (!source.length) {
    throw new Error("PDF source is empty")
  }

  return new Uint8Array(await source[0].arrayBuffer())
}

export type PdfBoxName = "TrimBox" | "BleedBox" | "ArtBox"

export const hasPdfBox = (page: unknown, boxName: PdfBoxName): boolean => {
  const pageNode = (
    page as {
      node?: {
        get?: (name: unknown) => unknown
        TrimBox?: () => unknown
        BleedBox?: () => unknown
        ArtBox?: () => unknown
      }
    }
  ).node

  if (!pageNode) {
    return false
  }

  if (boxName === "TrimBox" && typeof pageNode.TrimBox === "function") {
    return Boolean(pageNode.TrimBox())
  }
  if (boxName === "BleedBox" && typeof pageNode.BleedBox === "function") {
    return Boolean(pageNode.BleedBox())
  }
  if (boxName === "ArtBox" && typeof pageNode.ArtBox === "function") {
    return Boolean(pageNode.ArtBox())
  }

  return Boolean(pageNode.get?.(PDFName.of(boxName)))
}

const PDF_DEFAULT_DPI = 72
export const pointsToInches = (value: number, dpi = PDF_DEFAULT_DPI) =>
  value / dpi
